import React from "react";
import { Box, IconButton } from "@mui/material";
import MUITypography from "./MUITypography";
import CloseIcon from "@mui/icons-material/Close";
import { VM_Colors, vmPageTitleSx } from "../Styles/VMStyles";

function TitleAndCloseComponent({ title, onClick, bottomBorderLine, sx, titleAlign = "left" }) {
  return (
    <Box sx={{ position: "relative", borderBottom: bottomBorderLine?"1px solid #ddd":null, py: 4 ,my:2, ...sx}}>
      <MUITypography
        variant="pageTitle"
        sx={{
          ...vmPageTitleSx,
          color: VM_Colors.primary,
          textAlign: titleAlign,
          pr: 5,
          fontSize: 18,
          fontWeight: 700,
        }}
      >
        {title}
      </MUITypography>

      <IconButton
        onClick={onClick}
        size="small"
        sx={{
          position: "absolute",
          right: 0,
          top: "50%",
          transform: "translateY(-50%)",
          color: VM_Colors.primary,
          "&:hover": { backgroundColor: `${VM_Colors.primary}10` },
        }}
      >
        <CloseIcon sx={{ fontSize: 22, border: `1.5px solid ${VM_Colors.primary}`, borderRadius: "50%", p: "2px" }} />
      </IconButton>
    </Box>
  );
}

export default TitleAndCloseComponent;
